(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rbw-welcome-popup"]) return;
  try {
    
(() => {
  const bindWelcome = () => {
    const dialog = document.querySelector('[data-rbw-welcome]');
    if (!dialog || dialog.dataset.bound || typeof dialog.showModal !== 'function') return;
    dialog.dataset.bound = 'true';
    const editor = dialog.dataset.editor === 'true';
    const controller = new AbortController();
    const signal = controller.signal;
    const sessionKey = 'rbw-welcome-seen-v1';
    const dismissKey = 'rbw-welcome-dismissed-v1';
    const subscribedKey = 'rbw-welcome-subscribed-v1';
    const pendingKey = 'rbw-welcome-pending-v1';
    const read = (type, key) => { try { return window[type].getItem(key); } catch { return null; } };
    const write = (type, key, value) => { try { window[type].setItem(key, value); } catch {} };
    const remove = (type, key) => { try { window[type].removeItem(key); } catch {} };
    const languageSelect = dialog.querySelector('[data-rbw-email-language]');
    const languageTags = dialog.querySelector('[data-rbw-language-tags]');
    if (languageSelect && languageTags) {
      const saved = read('localStorage', 'rbw-email-language-manual');
      const preferred = (document.documentElement.lang || 'en').toLowerCase();
      languageSelect.value = saved === 'fr' || saved === 'en' ? saved : preferred.startsWith('fr') ? 'fr' : 'en';
      const syncLanguage = () => {
        languageTags.value = 'newsletter,rbw-welcome-popup,rbw-lang-' + languageSelect.value;
        
      };
      languageSelect.addEventListener('change', () => { syncLanguage(); write('localStorage', 'rbw-email-language-manual', languageSelect.value); }, { signal });
      syncLanguage();
    }
    let previousFocus;
    let shown = false;
    let elapsed = false;
    const draftPreview = () => Boolean(document.querySelector('iframe[src*="preview-bar"]')) || new URLSearchParams(location.search).has('preview_theme_id');
    let timer;
    let retry;
    let backdropDown = false;
    const dismissedRecently = () => Date.now() - Number(read('localStorage', dismissKey) || 0) < 7 * 86400000;
    const visible = element => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    const occupied = () => {
      if (document.hidden || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return true;
      return [...document.querySelectorAll('dialog[open], [aria-modal="true"], #shopify-pc__banner, #shopify-pc__prefs, #rbw-site-header details[open]')].some(element => element !== dialog && visible(element));
    };
    const open = preview => {
      if (dialog.open || !dialog.isConnected) return;
      if (!preview && occupied()) return;
      previousFocus = document.activeElement;
      dialog.showModal();
      shown = true;
      if (!editor) write('sessionStorage', sessionKey, '1');
      clearTimeout(timer);
      clearTimeout(retry);
    };
    const maybeOpen = () => {
      if (editor || shown || !elapsed) return;
      if (!draftPreview() && (read('sessionStorage', sessionKey) || read('localStorage', subscribedKey) || dismissedRecently())) return;
      if (occupied()) { schedule(); return; }
      open(false);
    };
    const schedule = () => {
      if (shown || editor) return;
      clearTimeout(retry);
      retry = setTimeout(maybeOpen, 350);
    };
    const close = () => { if (dialog.open) dialog.close(); };
    dialog.querySelectorAll('[data-rbw-welcome-close]').forEach(button => button.addEventListener('click', close, { signal }));
    dialog.addEventListener('close', () => {
      if (!editor) write('localStorage', dismissKey, String(Date.now()));
      if (previousFocus instanceof HTMLElement && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
    }, { signal });
    dialog.addEventListener('pointerdown', event => {
      const box = dialog.getBoundingClientRect();
      backdropDown = event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom);
    }, { signal });
    dialog.addEventListener('click', event => {
      const box = dialog.getBoundingClientRect();
      if (backdropDown && event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) close();
      backdropDown = false;
    }, { signal });
    document.querySelector('[data-rbw-welcome-preview]')?.addEventListener('click', () => open(true), { signal });
    const signupForm = dialog.querySelector('form');
    signupForm?.addEventListener('submit', event => {
      if (signupForm.dataset.submitting === 'true') { event.preventDefault(); return; }
      signupForm.dataset.submitting = 'true';
      signupForm.setAttribute('aria-busy', 'true');
      const submitButton = signupForm.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.disabled = true;
        const label = submitButton.querySelector('span');
        if (label) label.textContent = submitButton.dataset.rbwSending;
      }
      write('sessionStorage', pendingKey, String(Date.now()));
    }, { signal });
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      delete signupForm?.dataset.submitting;
      signupForm?.removeAttribute('aria-busy');
      const button = signupForm?.querySelector('button[type="submit"]');
      if (button) { button.disabled = false; button.querySelector('span').textContent = button.dataset.originalLabel; }
    }, { signal });
    const initialSubmit = signupForm?.querySelector('button[type="submit"]');
    if (initialSubmit) initialSubmit.dataset.originalLabel = initialSubmit.querySelector('span').textContent;
    document.addEventListener('scroll', schedule, { capture: true, passive: true, signal });
    document.addEventListener('click', schedule, { signal });
    document.addEventListener('focusout', schedule, { signal });
    document.addEventListener('visibilitychange', schedule, { signal });
    document.addEventListener('submit', event => {
      if (event.target !== dialog.querySelector('form') && event.target.querySelector('input[name="contact[email]"]')) shown = true;
    }, { signal });
    const response = dialog.querySelector('[data-rbw-welcome-state]');
    const pending = Number(read('sessionStorage', pendingKey) || 0);
    if (response?.dataset.rbwWelcomeState === 'success') {
      if (!editor) write('localStorage', subscribedKey, '1');
    }
    if (!editor && response && pending > Date.now() - 30 * 60000) {
      open(true);
      remove('sessionStorage', pendingKey);
    } else {
      timer = setTimeout(() => { elapsed = true; maybeOpen(); }, Number(dialog.dataset.delay) || 7000);
    }
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(dialog)) return;
      close();
      clearTimeout(timer);
      clearTimeout(retry);
      controller.abort();
    }, { signal });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindWelcome, { once: true });
  else bindWelcome();
  document.addEventListener('shopify:section:load', bindWelcome);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rbw-worn-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rbw-worn-gallery')) {
  customElements.define('rbw-worn-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('.rbw-worn__track');
      const dialog = this.querySelector('dialog');
      const full = this.querySelector('.rbw-worn__full');
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
        track.scrollBy({left: Number(button.dataset.step) * (track.querySelector('figure').getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      this.querySelectorAll('[data-original]').forEach(link => link.addEventListener('click', event => {
        if (typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        const image = link.querySelector('img');
        full.src = link.dataset.original;
        full.alt = image.alt;
        full.width = image.naturalWidth || image.width;
        full.height = image.naturalHeight || image.height;
        this.querySelector('.rbw-worn__original').href = link.href;
        dialog.showModal();
      }));
      this.querySelector('.rbw-worn__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {if (event.target === dialog) dialog.close();});
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
